// extracted by mini-css-extract-plugin
module.exports = {"container":"Scenarios_container__wY6nL","hero":"Scenarios_hero__wEW7A","sidebar":"Scenarios_sidebar__WZiIA","content":"Scenarios_content__x7Biv"};